// Fallback "local mode" for the admin area: when no backend/database is
// reachable (e.g. the offline test HTML, or a frontend deployed before the
// backend URL is set), the admin still works — custom options are kept in
// this browser's localStorage and shown in the configurator on this device.
// With a running backend the server-side list (shared by all visitors) is
// used instead.
export const LOCAL_ADMIN_KEY = ""; // Preview has no local admin access
const STORAGE = "sommet_custom_options_local";

export const loadLocalOptions = () => {
  try { return JSON.parse(localStorage.getItem(STORAGE) || "[]"); } catch { return []; }
};

// Returns true on success, false if the browser storage is full/unavailable.
export const saveLocalOptions = (list) => {
  try { localStorage.setItem(STORAGE, JSON.stringify(list)); return true; } catch { return false; }
};

const PAY_STORAGE = "sommet_payment_methods_local";
export const loadLocalPayments = () => {
  try { return JSON.parse(localStorage.getItem(PAY_STORAGE) || "[]"); } catch { return []; }
};
export const saveLocalPayments = (list) => {
  try { localStorage.setItem(PAY_STORAGE, JSON.stringify(list)); return true; } catch { return false; }
};
